import gameNames from '../../hub/data/GameIds';

const initialState = {
  isBackButtonVisible: true,
  questionsCount: 0,
  correctAnswersCount: 0,
  instructionsCount: 0,
  // grid items with placeholder
  question: [],
};

const roundStatisticsReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'INIT_ROUND_STATISTIC':
      return initialState;
    case 'INCREMENT_QUESTIONS_COUNT':
      return { ...state, questionsCount: state.questionsCount + 1 };
    case 'INCREMENT_CORRECT_ANSWERS_COUNT':
      return { ...state, correctAnswersCount: state.correctAnswersCount + 1 };
    case 'INCREMENT_INSTRUCTIONS_COUNT':
      return { ...state, instructionsCount: state.instructionsCount + 1 };
    case 'SET_QUESTION':
      return { ...state, question: action.payload.question };
    case 'DISABLE_BACK_BUTTON':
      return { ...state, isBackButtonVisible: false };
    default:
      return state;
  }
};

export default roundStatisticsReducer;
